import { Box } from "@chakra-ui/react"
import ThemeBackground from "@pathwright/ui/src/components/background/ThemeBackground"
import BGMode from "@pathwright/web/src/modules/components/BGMode"
import { usePathwrightContext } from "@pathwright/web/src/modules/pathwright/PathwrightContext"
import SpaceAuthForm from "@pathwright/web/src/modules/space/signup/SpaceAuthForm"
import { useHistory } from "react-router-dom"
import CreateSpacePrompt from "./CreateSpacePrompt"

function GlobalAuth() {
  const { me } = usePathwrightContext()
  const history = useHistory()

  return (
    <>
      <ThemeBackground />
      <Box
        maxW="md"
        minH="100vh"
        mx="auto"
        pos="relative"
        display="flex"
        flexDirection="column"
        justifyContent="center"
        className="GlobalAuth__wrapper"
      >
        <BGMode>
          <SpaceAuthForm
            onClickCreateSpace={() => history.push("/sign-up?step=space")}
          />
          {!me && <CreateSpacePrompt />}
        </BGMode>
      </Box>
    </>
  )
}

export default GlobalAuth
